import IndustryPageTemplate from "./IndustryPageTemplate";
import { accountantsData } from "@/data/accountants";

export default function AccountantsPage() {
  return <IndustryPageTemplate data={accountantsData} />;
}
